export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_6.da6e91f7.jpg";